export enum PdfExportStatus {
    Created = 0,
    Processing = 1,
    Success = 2,
    Failed = 3
}

export enum PdfExportingEvent {
    ExportingFinished = "ExportingFinished",
    ExportingQueueUpdated = "ExportingQueueUpdated"
}

export type PdfExportingHubHandler =
    PdfExportUpdateHandler |
    PdfExportSummaryUpdateHandler;

export type PdfExportUpdateHandler =
    (id: string, name?: string, date?: Date) => void;

export type PdfExportSummaryUpdateHandler =
    (summary: PdfExportLoginSummary) => void;

export interface PdfExportingHubSubscription {
    handler: PdfExportingHubHandler;
    event: PdfExportingEvent;
    listener?: string;
}

export interface PdfExportLoginSummary {
    loginId: string;
    processorType: string;

    pendingItems: number;
    processingItems: number;
    loginItemPositions: number[];
}

export interface PdfExportDataDTO {
    id: string;
    loginId: string;
    source?: string;
    message?: string;
    loginName?: string;
    fileName?: string;

    status: number;
    createdOn: Date;
    uploadedOn?: Date;
    lastModified: Date;
}